var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.buscarRelatorios.apply(null, arguments);
      }
    }
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Turma",
      "items": _vm.form.lists.listTurma,
      "outlined": "",
      "dense": "",
      "item-text": "nome",
      "item-value": "id"
    },
    model: {
      value: _vm.form.filters.turmaId,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "turmaId", $$v);
      },
      expression: "form.filters.turmaId"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Ano Letivo",
      "items": _vm.form.lists.listAnoLetivo,
      "outlined": "",
      "dense": "",
      "item-text": "ano",
      "item-value": "id"
    },
    model: {
      value: _vm.form.filters.anoLetivoId,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "anoLetivoId", $$v);
      },
      expression: "form.filters.anoLetivoId"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Ano/Serie",
      "items": _vm.form.lists.listSerie,
      "outlined": "",
      "dense": "",
      "item-text": "nome",
      "item-value": "id"
    },
    model: {
      value: _vm.form.filters.serieId,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "serieId", $$v);
      },
      expression: "form.filters.serieId"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Turno",
      "items": _vm.form.lists.listTurno,
      "outlined": "",
      "dense": "",
      "item-text": "descricao",
      "item-value": "id"
    },
    model: {
      value: _vm.form.filters.turnoId,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "turnoId", $$v);
      },
      expression: "form.filters.turnoId"
    }
  })], 1), _c('sca-select-ativo', {
    attrs: {
      "cols": 2,
      "config": {
        labelAtivo: 'Ativo',
        labelInativo: 'Inativo',
        label: 'Situação'
      }
    },
    model: {
      value: _vm.form.filters.situacao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "situacao", $$v);
      },
      expression: "form.filters.situacao"
    }
  })], 1), _c('v-row', {
    staticClass: "d-flex justify-center mt-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Município",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.municipio,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "municipio", $$v);
      },
      expression: "form.filters.municipio"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Escola",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.escola,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "escola", $$v);
      },
      expression: "form.filters.escola"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Professor",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.professor,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "professor", $$v);
      },
      expression: "form.filters.professor"
    }
  })], 1), _c('sca-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Data Início",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataInicial,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataInicial", $$v);
      },
      expression: "form.filters.dataInicial"
    }
  }), _c('sca-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Data Final",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataFinal,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataFinal", $$v);
      },
      expression: "form.filters.dataFinal"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sca-submit-button'), _c('sca-tooltip', {
    attrs: {
      "text": "Limpar",
      "icon": "mdi-eraser"
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5 printable",
    attrs: {
      "show-expand": "",
      "headers": _vm.headers,
      "items": _vm.form.lists.listRelatorios,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps,
      "sort-desc": true,
      "expanded": _vm.expanded
    },
    on: {
      "update:expanded": function ($event) {
        _vm.expanded = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: `item.nome`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.nome) + " ")];
      }
    }, {
      key: "expanded-item",
      fn: function (_ref2) {
        var headers = _ref2.headers,
          item = _ref2.item;
        return [_c('td', {
          staticClass: "permissoes",
          attrs: {
            "colspan": headers.length
          }
        }, [_c('v-chip-group', {
          attrs: {
            "active-class": "primary--text",
            "column": ""
          }
        }, [_c('v-chip', {
          staticClass: "chip-permissao"
        }, [_vm._v(" Professor(a) de Língua de Portuguesa: "), _c('b', [_vm._v(_vm._s(item.professorPortugues))])]), _c('v-chip', {
          staticClass: "chip-permissao"
        }, [_vm._v(" Professor(a) de Matemática: "), _c('b', [_vm._v(_vm._s(item.professorMatematica))])])], 1)], 1)];
      }
    }, {
      key: `item.ativo`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('sca-label-ativo', {
          attrs: {
            "ativo": item.ativo,
            "config": {
              labelAtivo: 'Ativo',
              labelInativo: 'Inativo'
            }
          }
        })];
      }
    }, {
      key: `item.dataAcao`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(_vm.$formatarDataHora(item.dataAcao)) + " ")];
      }
    }, {
      key: `item.acao`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_vm._v(" " + _vm._s(item.acao) + " ")];
      }
    }], null, true)
  }), _vm.form.lists.listRelatorios.length ? _c('sca-buttons', {
    attrs: {
      "actionText": "Baixar PDF",
      "cancelText": "Baixar CSV"
    },
    on: {
      "click": function ($event) {
        return _vm.baixarRelatorio('PDF');
      },
      "cancel": function ($event) {
        return _vm.baixarRelatorio('CSV');
      }
    }
  }) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }